import type { ContractResponse, PropertyFileResponse, SupplierInvoiceResponse } from '@/shared/api';
import { AusgehendInvoicesList } from './AusgehendInvoicesList';
import { ContractsList } from './ContractsList';
import { SupplierInvoicesList } from './SupplierInvoicesList';

export interface FachansichtCallbacks {
  onPreviewFileId: (propertyFileId: string) => void;
  onDownloadFileId: (propertyFileId: string) => void;
  onPreviewFile: (f: PropertyFileResponse) => void;
  onDownloadFile: (f: PropertyFileResponse) => void;
  onEditContract: (c: ContractResponse) => void;
  onEditInvoice: (inv: SupplierInvoiceResponse) => void;
}

interface Props extends FachansichtCallbacks {
  propertyId: string;
  category: string;
  ausgehendFiles: PropertyFileResponse[];
  /** Öffnet den Domain-Upload-Flow der aktuellen Kategorie (Verträge/Rechnungen). */
  onUploadHere: () => void;
}

/** Domain-Fachansicht der Kategorien 02 (Verträge) und 03 (Rechnungen) — statt der Rohdatei-Liste. */
export function AkteFachansicht({
  propertyId,
  category,
  ausgehendFiles,
  onPreviewFileId,
  onDownloadFileId,
  onPreviewFile,
  onDownloadFile,
  onEditContract,
  onEditInvoice,
  onUploadHere,
}: Props) {
  if (category === '02_Vertraege') {
    return (
      <ContractsList
        propertyId={propertyId}
        onDownload={onDownloadFileId}
        onPreview={onPreviewFileId}
        onEdit={onEditContract}
        onUploadHere={onUploadHere}
      />
    );
  }

  return (
    <div className="space-y-6">
      <SupplierInvoicesList
        propertyId={propertyId}
        onDownload={onDownloadFileId}
        onPreview={onPreviewFileId}
        onEdit={onEditInvoice}
        onUploadHere={onUploadHere}
      />
      {ausgehendFiles.length > 0 && (
        <AusgehendInvoicesList
          files={ausgehendFiles}
          onPreview={onPreviewFile}
          onDownload={onDownloadFile}
        />
      )}
    </div>
  );
}

/** Kategorien, die eine Domain-Fachansicht besitzen. */
export function hasFachansicht(category: string | null): boolean {
  return category === '02_Vertraege' || category === '03_Rechnungen';
}
